import { Button, Divider, Modal, Popconfirm, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useTasksTypesList } from 'src/pages/worldCup2026/tasks/hooks'
import { disableTaskTypeEvent } from 'src/pages/worldCup2026/tasks/model'
import { TaskType } from 'src/pages/worldCup2026/tasks/types'
import { TASKS_TYPES_NAMES } from 'src/pages/worldCup2026/const'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const ChangeTaskModal = ({ isVisible, onClose }: Props) => {
  const { tasksTypes, loading } = useTasksTypesList()

  const columns: ColumnsType<TaskType> = [
    {
      title: 'Task type',
      dataIndex: 'taskType',
      render: (item: string) =>
        TASKS_TYPES_NAMES[item as keyof typeof TASKS_TYPES_NAMES],
    },
    {
      title: '',
      align: 'center',
      render: (item: TaskType) => {
        if (item.disabledAt) {
          return <></>
        }
        return (
          <Popconfirm
            title="Disable task"
            description="Are you sure you want to disable this task?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              disableTaskTypeEvent({ id: item.taskType })
              onClose()
            }}
          >
            <Button color="volcano" variant="solid">
              Disable
            </Button>
          </Popconfirm>
        )
      },
    },
  ]

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Types of tasks</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      <Divider />
      <Table
        dataSource={tasksTypes}
        bordered={true}
        className="overflow-auto"
        loading={loading}
        rowKey={(record) => record.taskType}
        columns={columns}
        pagination={false}
      />
    </Modal>
  )
}
